import React, { useState } from 'react';
import Confirmation from './common/Confirmation';
import { Information } from './common';
import { messageUtility } from '../../utilities/messageUtility';

export const CcusCooperationConfirmDialog = ({ dialog }) => {
  const [checked, setChecked] = useState(false);

  const getMessage = () => {
    return (
      <React.Fragment>
        施工体制連携を開始するには、以下の注意事項をご確認いただく必要がございます。
        <br />
        <br />
        ＜注意事項＞
        <ul className='description'>
          <li>
            すでにCCUSで施工体制を登録している場合、登録済みのCCUS施工体制情報がすべて削除され、この現場の施工体制情報がCCUSに新規登録されます。
          </li>
          <li>
            他現場で同じCCUS現場IDを設定し施工体制連携を行っている場合、他現場のCCUS施工体制連携の情報がすべて削除されます。
          </li>
        </ul>
        <div className='checkbox-container'>
          <label className='checkbox'>
            <input
              type='checkbox'
              checked={checked}
              onChange={() => setChecked(!checked)}
            />
            <i className='i-square-checkbox i-2_5x' aria-hidden='true' />
            <span>上記の注意事項を確認した</span>
          </label>
        </div>
        連携を開始してよろしいですか？
      </React.Fragment>
    );
  };

  return (
    <Confirmation
      visible={true}
      rootClassName='CcusCooperationConfirmDialog'
      title={messageUtility.getMessage('I-000-174')}
      message={getMessage()}
      confirmButtonText={messageUtility.getMessage('I-000-175')}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      onConfirm={dialog.callback.onConfirm}
      onCancel={dialog.callback.onCancel}
      disabledConfirmButton={!checked}
      multilineText={true}
      tabFocus={true}
    />
  );
};

export const CcusCooperationErrorDialog = ({ dialog }) => {
  const getMessage = () => {
    return (
      <div>
        CCUSの現場契約情報の「標準APIの利用」が「利用する」に設定されていません。
        <br />
        施工体制を連携するためには「標準APIの利用」項目を「利用する」に設定する必要があります。
        <br />
        CCUSの画面上から現場契約情報の変更を行ってください。
        <br />
        CCUSの詳しい操作については、
        <a
          className='clickable-text'
          rel='noreferrer noopener'
          target='_blank'
          href='https://secure.okbiz.jp/faq-ccus/faq/show/983?site_domain=default'
        >
          こちら
        </a>
        をご確認ください。
      </div>
    );
  };

  return (
    <Information
      visible={true}
      rootClassName='dialog--wide'
      title={messageUtility.getMessage('I-000-179')}
      message={getMessage()}
      multilineText={true}
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={dialog.callback.onCancel}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/FieldCcusCooperationDialog.jsx